import React from "react";
import { Grid, Header, Transition, Button, Divider, Modal, Segment } from "semantic-ui-react";
import classNames from "classnames";
import CopyToClipboard from 'react-copy-html-to-clipboard';
import { connect } from 'react-redux'
import { googleTracking } from '../../../util';

const TextCopiedModal = props => {
  const { open, closeTextCopiedModal } = props;
  return (
    <Modal
      open={open}
      onClose={closeTextCopiedModal}
      basic
      className="mt-0"
      closeOnDimmerClick={false}
    >
      <Modal.Content scrolling className="ui centered grid mx-0 px-0" style={{ display: "flex", alignItems: "center", height: "100vh" }}>
        <Segment inverted className="not-yet-avail">
          <p className="text-white itc-mdbold avail__title">Text copied!</p>
          <p className="avail__desc">
            Remember to cc getfibre@fibrestream.ca
                  </p>
          <div>
            <Button secondary className="text-prime medium ml-2 mr-0 btn--full" onClick={closeTextCopiedModal}>Ok, got it</Button>
          </div>
        </Segment>
      </Modal.Content>
    </Modal>
  );
};

class RequestFibreStreamEmail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      animation: props.animation,
      seeSample: false,
      copied: false,
      textCopiedModal: false,
    };
    this.transitionBack = this.transitionBack.bind(this);
    this.transitionNext = this.transitionNext.bind(this);

    this.setSeeSample = this.setSeeSample.bind(this);
    this.copyText = this.copyText.bind(this);

    this.closeTextCopiedModal = this.closeTextCopiedModal.bind(this);
    this.openTextCopiedModal = this.openTextCopiedModal.bind(this);
  }

  componentDidMount() {
    const { result_type } = this.props;
    this.setState({
      visible: true
    });
    googleTracking({
      'event': 'virtualPageview',
      'pageview': '/unavailable&compatible/step3/request-fibrestream',
      'request_fibrestream_type_address_status': result_type === null ? 'typed' : 'clicked'
    });
  }

  transitionBack() {
    const { setServiceAvailable, result_type, changeStep, fromPage } = this.props;

    this.setState({
      animation: "fade left",
      visible: !this.state.visible
    });
    setTimeout(() => {
      if (fromPage === 'request-fibrestream' || result_type === null) {
        changeStep(9, "fade right");
      }
      else {
        setServiceAvailable(null, "fade right");
      }
    }, 400);
  }

  transitionNext() {
    const { changeStep } = this.props;

    this.setState({
      animation: "fade right",
      visible: !this.state.visible
    });
    setTimeout(() => {
      changeStep(6, "fade left")
    }, 400);
  }

  setSeeSample() {
    this.setState({
      seeSample: true
    });
  }

  copyText() {

    this.setState({
      copied: true
    });
    this.openTextCopiedModal();
    googleTracking({ 'event': 'virtualPageview', 'pageview': '/unavailable&compatible/step4/request-fibrestream-text-copied' })
  }

  getEmailContent() {
    return (
      `<div style="font-family: Arial; font-size: 13px;">
      Dear management,<br/><br/>
      Can we add FibreStream Internet to our building?<br/><br/>
      I’ve cc’d the FibreStream team, who can provide all the necessary information.<br/><br/>
      Let me know, thanks!<br/><br/>
      {your name} <br/>
      {your address/unit}
      </div>`
    );
  }

  openTextCopiedModal(e) {
    this.setState({
      textCopiedModal: true
    });
  }

  closeTextCopiedModal() {
    this.setState({
      textCopiedModal: false
    });
  }

  render() {
    const { visible, animation, seeSample, copied, textCopiedModal } = this.state;

    return (
      <div>
        <div className="back--icon" onClick={this.transitionBack} />
        <Transition visible={visible} duration={500} animation={animation}>
          <div>
            <Header className="title__main" as="h1" textAlign="center">
              Request FibreStream
            </Header>
            <Header.Subheader className="text-black">
              Service is not available but your building is compatible. Requesting FibreStream is easy – just send an email to your property manager or condo board.
            </Header.Subheader>
            <div className="pos-relative">
              <div className="btn--mail">
                <Button
                  size='medium'
                  onClick={this.setSeeSample}
                  className={classNames({ "d-none": seeSample }, "ml-auto mr-auto d-flex")}
                >
                  SEE SAMPLE EMAIL
                </Button>
              </div>
              <div className={classNames({ "sample-mail__text-opacity": !seeSample }, "sample-mail__text text-grey5")}>
                <Grid className="form__signup width__xs" columns={2}>
                  <Grid.Row className="py-0">
                    <Grid.Column className="px-0 text-grey5 text-uc f-size--14 mb-2 itc-mdbold" width={4}>
                      <strong>To:</strong>
                    </Grid.Column>
                    <Grid.Column className="px-0" width={12}>
                      {"{property manager's email}"}
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row className="py-0">
                    <Grid.Column className="px-0 text-grey5 text-uc f-size--14 itc-mdbold" width={4}>
                      <strong>cc</strong>
                    </Grid.Column>
                    <Grid.Column className="px-0" width={12}>
                      getfibre@fibrestream.ca
                    </Grid.Column>
                  </Grid.Row>
                  <Divider className="mx-0 sample-mail-divider" />
                  <Grid.Row className="py-0">
                    <Grid.Column className="px-0" width={4} />
                    <Grid.Column className="px-0" width={12}>
                      <div>
                        <p>Dear management,</p>
                        <p>Can we add FibreStream Internet to our building?</p>
                        <p>
                          I’ve cc’d the FibreStream team, who can provide all the necessary information.
                        </p>
                        <p>Let me know, thanks!</p>
                        <p>
                          {"{your name}"}
                          <br />
                          {"{your address/unit}"}
                        </p>
                      </div>
                    </Grid.Column>
                  </Grid.Row>

                  {(copied && !textCopiedModal) ?
                    <Grid.Row className='py-0'>
                      <div className="px-0 mx-auto">
                        <Button size="medium" className="mt-8 btn--sent-email" onClick={this.transitionNext}>
                          Ok, email sent!
                      </Button>
                      </div>
                    </Grid.Row>
                    :
                    <Grid.Row className='py-0'>
                      <Grid.Column className="px-0" width={4} />
                      <div className="px-0">
                        <CopyToClipboard text={this.getEmailContent()} options={{ asHtml: true }}>
                          <Button size="medium" color="black" onClick={this.copyText} className={textCopiedModal ? 'd-none' : 'mt-8'}>
                            COPY TEXT
                          </Button>
                        </CopyToClipboard>
                      </div>
                    </Grid.Row>
                  }
                </Grid>
              </div>
            </div>
            <TextCopiedModal open={textCopiedModal} closeTextCopiedModal={this.closeTextCopiedModal} />
          </div>
        </Transition>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    result_type: state.connection.result_type,
    fromPage: state.connection.fromPage
  }
}

export default connect(mapStateToProps)(RequestFibreStreamEmail);



// WEBPACK FOOTER //
// ./src/components/check-availability/service-not-available/RequestFibreStreamEmail.js